<template>
  <div class="wrapper">
    <div class="body">
      <div class="col-12">
        <div v-if="!loading">
          <div class="row">
            <div class="col-3">
              <div class="search-summarization">
                <input
                  type="text"
                  class="form-control"
                  id="input-action"
                  :placeholder="$t('aiReports.searchInput')"
                  v-model="filter"
                  @keyup="searchByFilter"
                />
                <button @click="cleanFilter" class="btn btn-outline-primary">
                  {{ $t('aiReports.searchButton') }}
                </button>
              </div>
            </div>
            <div class="button-new-summarization">

              <button
                class="btn btn-new-analysis"
                v-b-modal="`modal-new-aireport`"
              >
                {{ $t('aiReports.newAnalysis') }}
              </button>
              <modal-new-aireport :modalType = 'modalType'/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-table
                striped
                responsive
                id="table"
                class="mt-4"
                style="overflow: inherit"
                :items="items"
                :fields="fields"
                no-local-sorting
              >
                <template v-slot:cell(status)="row">
                  <div
                    :class="`flag-status flag-status-${row.item.status}`"
                  >
                    {{ row.item.status.toUpperCase() }}
                  </div>
                </template>
                <template v-slot:cell(visualization)="row">
                  <span class="table-icons">
                    <a @click="$router.push(`/summarization-view/${row.item._id}`)">
                      <font-awesome-icon :icon="['fas', 'eye']" />
                    </a>
                  </span>
                </template>
              </b-table>

              <div class="pagination-area">
                <paginate
                  v-model="page"
                  :pageCount="Math.ceil(itemsTotal / limit)"
                  :clickHandler="updateTable"
                  :prevText="'‹'"
                  :nextText="'›'"
                  :activeClass="'active'"
                  :containerClass="'pagination b-pagination'"
                  :pageClass="'page-item'"
                >
                </paginate>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="loader">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import api from '../../../../../../services/api';
import EventBus from '../../../../../../eventBus';
import ModalNewAireport from '@/components/organisms/reports/ai-analysis/modal-new-aireport';
import Paginate from 'vuejs-paginate';

export default {
  components: {
    ModalNewAireport,
    Paginate,
  },
  data: () => ({
    loading: false,
    userAuth: null,
    items: [],
    fields: [],
    filter: null,
    typingTimer: null,
    page: 1,
    limit: 10,
    itemsTotal: 0,
    modalType: 'Sumarização',
  }),

  computed: {
    ...mapState('actions', [
      'myActionId',
      'actionGroupData',
      'myActionsIds',
      'allActions',
      'allGroups',
    ]),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
      'ih1',
    ]),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.updateTable();
    },
    myActionId: function watchMyActionId() {
      this.updateTable();
    },
    myActionsIds: function watchMyActionsIds() {
      this.updateTable();
    },
    myIh1: function watchMyIh1() {
      this.updateTable();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.updateTable();
    },
    myIh2: function watchMyIh2() {
      this.updateTable();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.updateTable();
    },
    calendarDates: function watchDates() {
      this.updateTable();
    },
    myMetric: function watchMyMetric() {
      this.updateTable();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.updateTable();
    },
    'indicatorData.period': function watchIndicatorPeriod() {
      this.updateTable();
    },
    '$i18n.locale': function watchLocale() {
      this.updateTable();
    },
  },

  methods: {
    async updateTable() {
      this.loading = true;
      // call internal API for getting summarization table information
      const response = await api.get('summarizations', {
        params: {
          page: this.page,
          limit: this.limit,
          filter: this.filter,
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
        },
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      // load table information
      const summarizations = response.data.summarizations;
      for (let i = 0; i < summarizations.length; i += 1) {
        summarizations[i].createdAt = this.dateFormat(new Date(summarizations[i].createdAt));
        summarizations[i].period =
          `${this.dateFormat(new Date(summarizations[i].filter.startDate))} a
          ${this.dateFormat(new Date(summarizations[i].filter.endDate))}`;
        summarizations[i].qtd = summarizations[i].filter.commentedAnswers;
        summarizations[i].status = summarizations[i].status;
        summarizations[i].filters = this.formatFilter(summarizations[i].filter);
      }
      
      this.itemsTotal = response.data.total;
      this.page = response.data.page;
      this.limit = response.data.limit;

      this.items = summarizations;
      this.loading = false;
    },

    updateTranslate() {
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        this.updateTable();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.updateTable();
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy', { locale: pt });
      return date;
    },
    formatFilter(param) {
      let retStr = '';
      // param.actionGroups = ['64e779d79171266548efddf0', '64f1f8d6bd94eb37f06fadd5'];
      if (param.actionGroups.length > 0) {
        retStr = 'Grupos de Ações: '
        for (let i = 0; i < param.actionGroups.length; i += 1) {
          retStr += `"${this.getGroupName(param.actionGroups[i])}" `;
        }
      }
      // param.actions = ['5ebc0a17a15b0027bb3adb0d', '5ec2f90b6161496ecb0e1cf2'];
      if (param.actions.length > 0) {
        retStr += 'Ações: '
        for (let i = 0; i < param.actions.length; i += 1) {
          retStr += `"${this.getActionName(param.actions[i])}" `;
        }
      }
      // param.ih1s = ['5e7516c8e530fb40308e9c1a', '5e77b0c8ee62b900ed7543f4'];
      if (param.ih1s.length > 0) {
        retStr += 'Filiais: '
        for (let i = 0; i < param.ih1s.length; i += 1) {
          retStr += `"${this.getIh1Name(param.ih1s[i])}" `;
        }
      }
      // param.profiles = [ 'detrator', 'promotor'];
      if (param.profiles.length > 0) {
        retStr += 'Perfis: '
        for (let i = 0; i < param.profiles.length; i += 1) {
          retStr += `"${this.getProfileName(param.profiles[i])}" `;
        }
      }
      return retStr;
    },
    getGroupName(id) {
      for (let i = 0; i < this.allGroups.length; i += 1) {
        if (this.allGroups[i]._id === id) {
          return this.allGroups[i].name;
        }
      }
      return null;
    },
    getActionName(id) {
      for (let i = 0; i < this.allActions.length; i += 1) {
        if (this.allActions[i]._id === id) {
          return this.allActions[i].name;
        }
      }
      return null;
    },
    getIh1Name(id) {
      for (let i = 0; i < this.ih1.listFilters.length; i += 1) {
        if (this.ih1.listFilters[i]._id === id) {
          return this.ih1.listFilters[i].corporate_name;
        }
      }
      return null;
    },
    getProfileName(profile) {
      return profile.charAt(0).toUpperCase() + profile.slice(1);
    },
  },

  async mounted() {
    await this.updateTable();
    this.updateTranslate();
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      { key: 'controlId', label: this.$t('aiReports.summarizationTable.labels.id') },
      {
        key: 'filters',
        label: this.$t('aiReports.summarizationTable.labels.filters'),
      },
      {
        key: 'createdAt',
        label: this.$t('aiReports.summarizationTable.labels.createdAt'),
      },
      {
        key: 'period',
        label: this.$t('aiReports.summarizationTable.labels.period'),
      },
      {
        key: 'qtd',
        label: this.$t('aiReports.summarizationTable.labels.qtd'),
      },
      {
        key: 'status',
        label: this.$t('aiReports.summarizationTable.labels.status'),
      },
      {
        key: 'visualization',
        label: this.$t('aiReports.summarizationTable.labels.visualization'),
        class: 'center-icon',
      },
    ];
    this.items = [];
    EventBus.$on('refreshlist', (reportSelect) => {
      if (reportSelect === 'summarizations') {
        this.updateTable();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.align-header {
  display: flex;
  justify-content: space-between;
}
.wrapper {
  padding: 8px;
  padding-top: 0px;
  padding-right: 13px;
}
.body {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}
.body h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}
.header {
  display: flex;
  flex-direction: row;

  .header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
  }
}
.search-summarization {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
.button-new-summarization {
  position: absolute;
  right: 20px;
}
.btn-new-analysis {
  color: white;
  background: #3DB374;
}
.flag-status {
  display: flex;
  width: 120px;
  padding: 2px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  color: white;
}
.flag-status-processando {
  background: #BABABA;
}
.flag-status-concluido {
  background: #37E688;
}
.flag-status-falha {
  background: #E1513D;
}
.table-icons {
  color: #3DB374;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.pagination-area >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

</style>
<style lang="scss">
.center-icon {
  text-align: center !important;
  cursor: pointer;
}
.pagination-area .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/ai-analysis/ai-summarization-reports/summarization/index.vue